import styled, { css } from 'styled-components';
import paragraphStyles from '../styles/paragraphStyles';
import paragraphLeadStyles from '../styles/paragraphLeadStyles';
var ListItem = styled.li.withConfig({
  displayName: "ListItem",
  componentId: "wl7vmx-0"
})(["", " ", ""], paragraphStyles, function (_ref) {
  var lead = _ref.lead;
  return lead && css(["", ""], paragraphLeadStyles);
});
export default ListItem;